<template>
  <div class="info-wrapper">
    <img class="logo-image" src="../../static/images/logo.png" />
    <h3 class="title">{{info.title}}</h3>
    <div class="divider" />
    <div  v-if="info.galleryMini" class="carousel">
      <carousel
        ref="gallery"
        :navigationEnabled="true"
        :paginationEnabled="false"
        :perPage="1">
        <slide
          :key="index"
          v-for="(img, index) in info.galleryMini">
          <div class="slider-image-wrapper">
            <img class="slider-image" @click="galleryOnClick" :src="img" />
          </div>
        </slide>
      </carousel>
      <div class="image-note">{{galleryLabel}}</div>
    </div>
    <div v-if="info.image">
      <img class="cover-image" :src="info.image" />
    </div>
    <div class="info-text" v-html="info.description" />
    <div class="navigation-wrapper">
      <button class="navigation-link left" :disabled="!showPrevLink" @click="toggleMarker('prev')">Previous</button>
      <button class="navigation-link" @click="toggleMarker('home')">Home</button>
      <button class="navigation-link right" :disabled="!showNextLink" @click="toggleMarker('next')">Next</button>
    </div>
    <div v-if="info.embed" v-html="info.embed"/>
    <div v-if="showScrollHint" class="scroll-hint bounce" />
  </div>
</template>

<script>
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    components: { Carousel, Slide },
    props: ['selected', 'toggleGallery', 'toggleMarker', 'locationsQty'],
    computed: {
      info () {
        return this.selected.info
      },
      galleryLabel () {
        return this.expandGallery ? '(Click on image to close)' : '(Click on image to expand)'
      },
      showNextLink () {
        return this.selected.id < this.locationsQty
      },
      showPrevLink () {
        return this.selected.id > 1
      },
      tweetId () {
        console.log(this.selected.info.tweet)
      }
    },
    data () {
      return {
        expandGallery: false,
        showScrollHint: true
      }
    },
    methods: {
      galleryOnClick () {
        setTimeout(() =>
          window.scrollTo(0, 0),
        100)
        this.toggleGallery()
        this.$refs.gallery.goToPage(0)
      }
    }
  }
</script>
<style>
  .carousel {
    width:400px;
  }
  .VueCarousel-navigation-prev {
    margin-left: 30px !important;
  }
  .VueCarousel-navigation-next {
    margin-right: 30px !important;
  }
  .carousel.expanded .VueCarousel-navigation-prev {
    left: 24px !important;
  }
  .VueCarousel-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>
<style scoped>
 @import url('https://fonts.googleapis.com/css?family=Arapey');

.logo-image {
  margin-bottom: 10px;
}

.carousel {
  background: #eee;
  height: 400px;
}

.title {
  margin:0px;
  font-family: 'Arapey', serif;
  font-size: 1.2em;
  height: 40px;
  margin-top: 20px;
}

.address {
  margin:0px;
  font-family: 'Arapey', serif;
  font-size:1.5em;
  height: 40px;
}
.divider {
  width: 50px;
  height: 2px;
  border-bottom: 2px solid #999;
  margin: 10px;
}
.price {
  margin:0px;
  margin-bottom: 12px;
  font-family: 'Arapey', serif;
  color: #D96540;
  font-size: 2em;
  margin-bottom: 20px;
}

.info-wrapper {
  width:100%;
  height: 100%;
  padding: 8px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  align-items: center;
  box-sizing: border-box;
  color:#FFF;
  position: relative;
  justify-content: flex-start;

}
.cover-image {
  max-width:100%;
  max-height: 50vh;
}
.slider-image-wrapper {
  width: 400px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.slider-image {
  max-width: 85%;
  height: auto;
  max-height: 400px;
}

.image-note {
  font-size: small;
  margin-bottom: 4px;
}
.info-text {
  padding: 10px;
  text-align: justify;
  font-family: serif;
  text-indent: 0.5em;
}

.navigation-wrapper {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items:center;
  justify-content: space-between;
  width:100%;
  margin:12px;
  padding:8px;
  margin-top: 24px;
}

  .navigation-link:disabled {
    opacity: 0.5;
  }

  .navigation-link {
    text-align: center;
    font-family: 'Arapey', serif;
    width: 70px;
    height: 50px;
    padding: 8px;
    box-sizing: border-box;
    border:none;
    background: transparent;
    font-size: 1em;
    line-height: 1;
    outline: none;
    cursor: pointer;
    display: block;
    font-weight: bold;
    background-repeat: no-repeat;
    color:#FFF;
  }
  .navigation-link:focused, .navigation-link:active {
    outline: none;
    transform: scale(1.1);
  }

  .navigation-link.left {
    text-align: left;
    background-image: url('../../static/images/arrow-left.png');
    background-position: left center;
    padding-left: 20px;
  }

  .navigation-link.right {
    text-align: right;
    background-image: url('../../static/images/arrow-right.png');
    background-position: right center;
    padding-right: 20px;
  }

  .scroll-hint {
    display: none;
    position: absolute;
    bottom: 10px;
    left: 50%;
    background-image: url('../../static/images/scroll.png');
    background-size: 50%;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: #FFF;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    margin-left: -15px;
    border: 1px solid #ccc;
  }

  @media (max-width:450px) {
      .scroll-hint {
        display: none;
        position: fixed;
        z-index: 10;
      }
  }
  .bounce {
    animation: bounce 2s infinite;
  }

  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-30px);
    }
    60% {
      transform: translateY(-15px);
    }
  }

</style>



// WEBPACK FOOTER //
// Info.vue?45504b81